import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'lib-formly-password',
  imports: [
    NzFormModule,
    ReactiveFormsModule,
    CommonModule,
    NzInputModule,
    NzIconModule,
    FormlyModule,
  ],
  templateUrl: './formly-password.component.html',
  styleUrl: './formly-password.component.scss',
})
export class FormlyPasswordComponent extends FieldType<FieldTypeConfig> {
  passwordVisible = false;
  get errorState() {
    return this.showError ? 'error' : '';
  }
}
